import { AsterChip } from 'asterX-UI/Chip'
import { getValidDate } from 'lib/utils'

export const clientTypes = [
  { label: 'Основные данные', code: 'basicData' },
  { label: 'История кредитов', code: 'contractHistory' },
  { label: 'Данные документа', code: 'documents' },
  { label: 'Адрес', code: 'address' },
  { label: 'Информация о месте работы', code: 'workplace' },
  { label: 'Дополнительные контакты', code: 'additionalContacts' }
]

export const contractHistoryColumns = [
  'Номер контракта ',
  'Дата создания',
  'Кредитный продукт ',
  'Сумма займа',
  'Статус',
  'Подразделение',
  'Макс. дней просрочки',
  'Дата закрытия'
]

export const contractHistoryRows = list => {
  if (!list) {
    return []
  }

  return list?.map(item => {
    return [
      item?.contractId || '-',
      getValidDate(item?.creationDate),
      item?.creditProductName || '-',
      item?.loanAmount ? `${item?.loanAmount?.toString()?.thousandSeparator()} ₸` : '-',
      <AsterChip
        label={item?.closedStatusName || 'нет данных'}
        color={item?.closedStatusName === null ? 'gray' : item?.closedStatusName === 'Погашен' ? 'greenOut' : 'redOut'}
      />,
      '-',
      item?.maxOverdueDays || '-',
      getValidDate(item?.closeDate)
    ]
  })
}

export const getBasicData = data => {
  const basicData = [
    { label: 'Фамилия', value: data?.client?.lastName || '-' },
    { label: 'Имя', value: data?.client?.firstName || '-' },
    { label: 'Отчество', value: data?.client?.patronymic || '-' },
    { label: 'Пол', value: data?.client?.genderName || '-' },
    { label: 'День рождения', value: getValidDate(data?.client?.birthDate) },
    { label: 'Место рождения', value: data?.client?.birthPlace || '-' },
    { label: 'email', value: data?.client?.email || '-' },
    { label: 'Мобильный телефон', value: data?.client?.mobilePhone?.toString()?.toPhone() || '-' },
    { label: 'ИНН', value: data?.client?.iin || '-' },
    { label: 'СНИЛС', value: data?.client?.snils || '-' },
    { label: 'Количество детей', value: data?.client?.childrenCount || '-' },
    { label: 'Кол-во совершеннолетних детей', value: data?.client?.adultChildrenCount || '-' },
    { label: 'Количество иждивенцев', value: data?.client?.dependentsCount || '-' },
    { label: 'Ежемесячное погашение', value: data?.client?.monthlyCreditPayment || 0 }
  ]

  if (data?.additionalPhones) {
    basicData.push({ label: 'Дополнительный телефон', value: data.additionalPhones })
  }

  if (data?.additionalEmails) {
    basicData.push({ label: 'Дополнительный email', value: data.additionalEmails })
  }

  return basicData
}

export const getDocumentsData = client => {
  return [
    { label: 'Тип документа', value: client?.documentType || '-' },
    { label: 'ИНН', value: client?.iin || '-' },
    { label: 'Номер', value: client?.documentNumber || '-' },
    { label: 'Дата выдачи', value: getValidDate(client?.issueDate) },
    { label: 'Дата истечения', value: getValidDate(client?.closeDate) },
    { label: 'Кем выдан', value: client?.docIssueMan || '-' },
    { label: 'Адрес проживания (id)', value: client?.addressId || '-' },
    { label: 'Адрес прописки (id)', value: client?.registrationAddressId || '-' }
  ]
}

export const getAddressData = address => {
  return [
    { label: 'Страна', value: address?.countryName || '-' },
    { label: 'Старый адрес', value: address?.oldAddressText || '-' },
    { label: 'Регион', value: address?.regionName || '-' },
    { label: 'Населённый пункт', value: address?.localityName || '-' },
    { label: 'Район', value: address?.ruralDistrictName || '-' },
    { label: 'Улица', value: address?.streetName || '-' },
    { label: 'Почтовый индекс', value: address?.postalCode || 'нет данных' },
    { label: 'Дом', value: address?.houseNumber || '-' },
    { label: 'Квартира', value: address?.apartmentNumber || '-' },
    { label: 'Ближайшая станция метро', value: address?.metroStation || 'б/н' }
  ]
}

export const getWorkplaceData = client => {
  return [
    { label: 'Место работы', value: client?.workPlace || '-' },
    { label: 'Вид деятельности', value: client?.activityTypeName || '-' },
    { label: 'Должность', value: client?.workPost || '-' },
    { label: 'Общий стаж работы (мес)', value: `${client?.workAge}` || '-' },
    { label: 'Общий ежемесячный доход', value: `${client?.meanIncome?.toString()?.thousandSeparator() || 0} ₸` || '-' },
    { label: 'Стаж работы в организации (мес)', value: `${client?.actualWorkage || 0}` || '-' },
    { label: 'Рабочий телефон', value: client?.workPhone?.toString()?.toPhone() || '-' }
  ]
}

export const getAdditionalContacts = contacts => {
  return [
    { label: 'Фамилия', value: contacts?.lastName || '-' },
    { label: 'Имя', value: contacts?.firstName || '-' },
    { label: 'Отчество', value: contacts?.patronymic || '-' },
    { label: 'Место работы', value: contacts?.workplace || '-' },
    { label: 'Степень родства', value: contacts?.relativeName || '-' },
    { label: 'Резидент', value: contacts?.resident ? 'да' : 'нет' },
    { label: 'Телефон', value: contacts?.telephone?.toString()?.toPhone() || '-' },
    { label: 'ИНН', value: contacts?.iin || '-' },
    { label: 'Email', value: contacts?.email || '-' },
    { label: 'Комментарий', value: contacts?.comments || '-' }
  ]
}
